import { jsx as _jsx } from "react/jsx-runtime";
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import { useSTRows } from '../SmartTableContext';
import { cellStyle } from '../styles';
import { defineStyles } from '../../theme';
const styles = defineStyles({
    root: {
        ...cellStyle,
    },
    checkbox: {
        marginRight: 1,
        padding: 0,
    },
});
const TableSelectionCell = () => {
    const { selectionCount, deselectAll } = useSTRows();
    return (_jsx(TableCell, { sx: {
            ...styles.root,
            position: 'sticky',
            left: 0,
            zIndex: 7,
            backgroundColor: 'background.paper',
        }, children: selectionCount > 0 ? (_jsx(Checkbox, { onClick: deselectAll, checked: false, indeterminate: selectionCount > 0, sx: styles.checkbox })) : (_jsx("div", { style: { width: 24, marginRight: 8 }, children: "\u00A0" })) }));
};
export default TableSelectionCell;
//# sourceMappingURL=TableSelectionCell.js.map